<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8">
      <div class="relative flmid">
        <div class="input-group flgrow">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="dealerRequestModel.searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>
        <div class="ml-2 advanced-search-box">
          <button type="button" class="btn btn-primary" (click)="onAdvanceSearch()" aria-label="Center Align">
            <i class="fa fa-search-plus" aria-hidden="true"></i>
          </button>
          <div class="searchbox card fix rt" *ngIf="dealerRequestModel.isAdvanceSearch">
            <div class="form-row mt-3 mb-2">
              <div class="col-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="keyLocation"
                    [(ngModel)]="dealerRequestModel.keyLocation">
                  <label class="custom-control-label" for="keyLocation" translate>lblKeyLocation</label>
                </div>
              </div>
              <div class="col-6">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="onlinePayment"
                    [(ngModel)]="dealerRequestModel.onlinePayment">
                  <label class="custom-control-label" for="onlinePayment" translate>lblonlinePayment</label>
                </div>
              </div>
              <div class="col-12 mt-3">
                <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                  (change)="StatusChange($event,true)">
                  <ng-option *ngFor="let status of StatusList" [value]="status.id">
                    {{status.value}}
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col text-right">
                <button type="submit" (click)="AdvanceSearchSubmit()" class="btn btn-primary mr-sm-2" translate>lblApply
                </button>
                <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-2" translate>lblReset
                </button>
                <button (click)="onClose()" class="btn btn-outline-tertiary" translate>lblClose
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
      <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
        (change)="StatusChange($event,false)">
        <ng-option *ngFor="let status of StatusList" [value]="status.id">
          {{status.value}}
        </ng-option>
      </ng-select>
    </div>
    <div class="col-auto ml-auto">
      <button type="button" (click)="exportAsXLSX(documentTypes.Excel)" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
        aria-label="Center Align">
        <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button>
      <button class="ml-2 btn btn-link icon-pdf" type="button" (click)="onDownloadPDF(documentTypes.Pdf)"
        ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
        <em class="far fa-file fa-2x"></em>
        <span class="bdg">PDF</span>
      </button>
      <button type="button" *ngIf="userRoleRightsDetails.canAdd" (click)="onAdd()" type="reset"
        class="add-button btn btn-primary ml-2" aria-label="Center Align" translate>lblAddDealer</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex  justify-content-between">
          <h4 class="card-title" translate>lblDealers</h4>
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 20%" scope="col" sortable="name" (sort)="onSort($event)"><span
                    translate>lblName</span></th>
                <th style="width: 10%" scope="col" *ngIf = "isShowLocationCode" translate>lblDealershipsId</th>
                <th style="width: 17%" scope="col" translate>lblAddress</th>
                <th style="width: 20%" scope="col" translate>lblLandline</th>
                <th style="width: 20%" scope="col" translate>lblMobile</th>
                <th style="width: 10%" scope="col" translate>lblEmail</th>
                <th style="width: 5%" class="text-center" scope="col" sortable="isActive" (sort)="onSort($event)"
                  translate>lblActive</th>
                <th style="width: 5%" class="text-center" scope="col" sortable="keyLocation" (sort)="onSort($event)"
                  translate *ngIf="!isShareBoxEnabled">lblKeyLocation</th>
                <th style="width: 5%" class="text-center" scope="col" sortable="keyLocation" (sort)="onSort($event)"
                  translate *ngIf="isShareBoxEnabled">lblSharebox</th>
                <th style="width: 5%" class="text-center" scope="col" sortable="onlinePayment" (sort)="onSort($event)"
                  translate>lblonlinePayment
                </th>
                <th style="width:50px" class="text-center" scope="col" sortable="dmsSyncDate" (sort)="onSort($event)"  
                *ngIf="isOLB" translate>lbllastSyncdate</th>
                <th style="width: 120px" class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="dealerList?.length>0; else load_else">
                <tr *ngFor="let dealer of dealerList; let i=index">
                  <td>{{ dealer.row }}</td>
                  <td>
                    <ngb-highlight [result]="dealer.name"></ngb-highlight>
                  </td>
                  <td *ngIf = "isShowLocationCode">
                    <ngb-highlight [result]="dealer.locationCode"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealer.address"></ngb-highlight>
                  </td>
                  <td>
                    <span
                      *ngIf="dealer && dealer.landlineCode && dealer.landlineCode!=='0'">+{{dealer.landlineCode}}-</span>
                    <ngb-highlight [result]="dealer.landline?dealer.landline:''">
                    </ngb-highlight>
                  </td>
                  <td>
                    <span *ngIf="dealer && dealer.mobileCode && dealer.mobileCode!=='0'">+{{dealer.mobileCode}}-</span>
                    <ngb-highlight [result]="dealer.mobile?dealer.mobile:''">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="dealer.email">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="dealer.isActive == 'true'"></em>
                    <em class="fas fa-close" *ngIf="dealer.isActive == 'false'"></em>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="dealer.keyLocation  == 'true'"></em>
                    <em class="fas fa-close" *ngIf="dealer.keyLocation == 'false'"></em>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="dealer.onlinePayment  == 'true'"></em>
                    <em class="fas fa-close" *ngIf="dealer.onlinePayment == 'false'"></em>
                  </td>
                  <td class="text-center" *ngIf="isOLB">
                      {{ dealer.dmsSyncDate | date:'short'}}
                  </td>
                  <td class="nowrap text-center">
                    <ng-container *ngIf="isOLB">
                        <a class="btn btn-ico"
                            ngbTooltip="{{ 'lblSyncToOLB' | translate }}"
                            tooltipClass="custom-revert"
                            [class.invisible]="dealer.dmsSyncStatus === true"
                            (click)="onSyncToDms(dealer.dealerId)">
                            <em class="fas fa-sync fa-lg  "></em>
                        </a>
                        <span class="ico-div"
                            [class.invisible]="dealer.dmsSyncStatus === true"></span>
                        <a class="btn btn-ico"
                            ngbTooltip="{{ 'lblOLBSyncFailedlog' | translate }}"
                            tooltipClass="custom-revert"
                            [class.invisible]="dealer.dmsSyncStatus === true"
                            (click)="viewException(dealer.dealerDmsNo)">
                            <em class="fas fa-clipboard-list fa-lg  "></em>
                        </a>
                        <span class="ico-div"
                            [class.invisible]="dealer.dmsSyncStatus === true"></span>
                    </ng-container>
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canEdit" (click)="editDealer(dealer.dealerId)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                      *ngIf="userRoleRightsDetails.canDelete" (click)="deleteDealer(dealer.dealerId)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>


                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>No Records Found</td>
                </tr>
              </ng-template>
            </tbody>
          </table>

        </div>
      </div>

    </div>
  </div>
  <table style="display: none;" class="table" id="dealerPdf">
    <thead>
      <tr>
        <th style="width: 55px" scope="col">#</th>
        <th style="width: 15%" scope="col"><span translate>lblName</span></th>
        <th style="width: 17%" scope="col" translate>lblAddress</th>
        <th style="width: 7%" scope="col" translate>lblLandline</th>
        <th style="width: 13%" scope="col" translate>lblMobile</th>
        <th style="width: 10%" scope="col" translate>lblEmail</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="dealerListPdf?.length>0; else load_else">
        <tr *ngFor="let dealer of dealerListPdf; let i=index">
          <td>{{ dealer.row }}</td>
          <td>
            <ngb-highlight [result]="dealer.name"></ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="dealer.address"></ngb-highlight>
          </td>
          <td>
            <span *ngIf="dealer && dealer.landlineCode && dealer.landlineCode!=='0'">+{{dealer.landlineCode}}-</span>
            <ngb-highlight [result]="dealer.landline?dealer.landline:''">
            </ngb-highlight>
          </td>
          <td>
            <span *ngIf="dealer && dealer.mobileCode && dealer.mobileCode!=='0'">+{{dealer.mobileCode}}-</span>
            <ngb-highlight [result]="dealer.mobile?dealer.mobile:''">
            </ngb-highlight>
          </td>
          <td>
            <ngb-highlight [result]="dealer.email">
            </ngb-highlight>
          </td>
        </tr>
      </ng-container>
      <ng-template #load_else>
        <tr>
          <td colspan="8" class="no-record" translate>No Records Found</td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>
<!-- new theme implementation ends -->